import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebaseConfig";

export const REPORTS_COL = "student_progress_reports";

export async function fetchReportsForStudent(studentId) {
  if (!studentId) return [];
  const q = query(
    collection(db, REPORTS_COL),
    where("studentId", "==", studentId),
    orderBy("generatedAt", "desc"),
    limit(100)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function fetchReportById(reportId) {
  if (!reportId) return null;
  const ref = doc(db, REPORTS_COL, reportId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

export async function saveProgressReport(reportId, data) {
  const ref = doc(db, REPORTS_COL, reportId);
  await setDoc(ref, data);
}

export async function renameReport(reportId, newName) {
  if (!reportId) throw new Error("reportId is required");
  const ref = doc(db, REPORTS_COL, reportId);
  await updateDoc(ref, {
    customName: String(newName || "").trim(),
    updatedAt: Timestamp.now(),
  });
}

export async function deleteReport(reportId) {
  if (!reportId) throw new Error("reportId is required");
  const ref = doc(db, REPORTS_COL, reportId);
  await deleteDoc(ref);
}

// Builds a unique but readable report ID
export function buildReportId(studentId, startDate, endDate, generatedAtMs) {
  const datePart = `${startDate}_${endDate}`.replace(/-/g, "");
  const ts = String(generatedAtMs || Date.now()).slice(-8);
  const sid = String(studentId || "").slice(0, 12);
  return `rpt_${sid}_${datePart}_${ts}`;
}
